/**
 * Created by tofaelraju on 3/24/17.
 */

import actions from '../actions/types';

export default function reducer(state = {
  isLoading: false,
  notifyUser: false,
  notificationMessage: ''
}, action) {
  switch (action.type) {

    case actions.ASYNC_REQ_START: {
      state = {...state,
        isLoading: true
      }
      break;
    }

    case actions.ASYNC_REQ_END: {
      state = {...state,
        isLoading: false
      }
      break;
    }
    case actions.NOTIFIY_USER: {
      state = {...state,
        notifyUser: true,
        notificationMessage: action.data.message
      }
      break;
    }
    case actions.RESET_FEEDBACKBAR: {
      state = {...state,
        notifyUser: false,
        notificationMessage: ''
      }
      break;
    }
    default:
      return state;
  }
  return state;
}


// WEBPACK FOOTER //
// ./src/reducers/application.js